<div class="cat__footer text-center">
  <span>© {{ year }} <a target="_blank">Armatus Dealer Uplift </a> All rights reserved</span>
</div>
